(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobo-featured-articles"] && !Shopify.designMode) return;
  try {
    
  class NoboStoriesCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.nobo-stories__viewport');
      this.track = this.querySelector('.nobo-stories__track');

      if (!this.viewport || !this.track) return;

      this.position = 0;
      this.startX = 0;
      this.startPosition = 0;
      this.dragging = false;
      this.didDrag = false;
      this.resumeTimer = null;
      this.didDragResetTimer = null;

      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('lostpointercapture', this.onPointerUp);
      this.addEventListener('click', this.onClick, true);
    }

    disconnectedCallback() {
      if (!this.viewport) return;

      this.viewport.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport.removeEventListener('pointermove', this.onPointerMove);
      this.viewport.removeEventListener('pointerup', this.onPointerUp);
      this.viewport.removeEventListener('pointercancel', this.onPointerUp);
      this.viewport.removeEventListener('lostpointercapture', this.onPointerUp);
      this.removeEventListener('click', this.onClick, true);
      window.clearTimeout(this.resumeTimer);
      window.clearTimeout(this.didDragResetTimer);
    }

    onPointerDown = (event) => {
      if (window.matchMedia('(max-width: 749px)').matches) return;
      if (event.button !== undefined && event.button !== 0) return;

      this.dragging = true;
      this.didDrag = false;
      window.clearTimeout(this.resumeTimer);
      window.clearTimeout(this.didDragResetTimer);
      this.startX = event.clientX;
      this.startPosition = this.getCurrentPosition();
      this.position = this.startPosition;
    };

    onPointerMove = (event) => {
      if (!this.dragging) return;

      const delta = event.clientX - this.startX;
      const dragThreshold = event.pointerType === 'touch' ? 8 : 4;
      if (!this.didDrag && Math.abs(delta) <= dragThreshold) return;

      if (!this.didDrag) {
        this.didDrag = true;
        this.classList.add('nobo-stories--dragging', 'nobo-stories--user-paused');
        this.viewport.setPointerCapture(event.pointerId);
      }

      this.position = this.startPosition + delta;
      this.position = this.wrapPosition(this.position);
      this.applyPosition();
      event.preventDefault();
    };

    onPointerUp = (event) => {
      if (!this.dragging) return;

      this.dragging = false;

      if (!this.didDrag) return;

      this.classList.remove('nobo-stories--dragging');

      if (this.viewport.hasPointerCapture(event.pointerId)) {
        this.viewport.releasePointerCapture(event.pointerId);
      }

      this.resumeTimer = window.setTimeout(() => {
        this.classList.remove('nobo-stories--user-paused');
      }, 2200);

      this.didDragResetTimer = window.setTimeout(() => {
        this.didDrag = false;
      }, 0);
    };

    onClick = (event) => {
      if (!this.didDrag) return;

      event.preventDefault();
      event.stopPropagation();
      window.clearTimeout(this.didDragResetTimer);
      this.didDrag = false;
    };

    getCurrentPosition() {
      const style = window.getComputedStyle(this.track);
      const transform = style.transform;

      if (!transform || transform === 'none') {
        return this.position || 0;
      }

      const matrix = new DOMMatrixReadOnly(transform);
      return matrix.m41;
    }

    getLoopWidth() {
      const cards = this.track.querySelectorAll('.nobo-stories__card');
      const visibleCount = Math.floor(cards.length / 2);

      if (!visibleCount) return 0;

      const card = cards[0];
      const gap = parseFloat(window.getComputedStyle(this.track).columnGap || window.getComputedStyle(this.track).gap || 0);
      return (card.getBoundingClientRect().width + gap) * visibleCount;
    }

    wrapPosition(position) {
      const loopWidth = this.getLoopWidth();

      if (!loopWidth) return position;

      while (position > 0) {
        position -= loopWidth;
      }

      while (position < -loopWidth) {
        position += loopWidth;
      }

      return position;
    }

    applyPosition() {
      this.track.style.transform = `translateX(${this.position}px)`;
    }
  }

  if (!customElements.get('nobo-stories-carousel')) {
    customElements.define('nobo-stories-carousel', NoboStoriesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobo-stories"] && !Shopify.designMode) return;
  try {
    
  class NoboStoriesCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.nobo-stories__viewport');
      this.track = this.querySelector('.nobo-stories__track');

      if (!this.viewport || !this.track) return;

      this.position = 0;
      this.startX = 0;
      this.startPosition = 0;
      this.dragging = false;
      this.didDrag = false;
      this.resumeTimer = null;

      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('lostpointercapture', this.onPointerUp);
      this.addEventListener('click', this.onClick, true);
    }

    disconnectedCallback() {
      if (!this.viewport) return;

      this.viewport.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport.removeEventListener('pointermove', this.onPointerMove);
      this.viewport.removeEventListener('pointerup', this.onPointerUp);
      this.viewport.removeEventListener('pointercancel', this.onPointerUp);
      this.viewport.removeEventListener('lostpointercapture', this.onPointerUp);
      this.removeEventListener('click', this.onClick, true);
      window.clearTimeout(this.resumeTimer);
    }

    onPointerDown = (event) => {
      if (window.matchMedia('(max-width: 749px)').matches) return;
      if (event.button !== undefined && event.button !== 0) return;

      this.dragging = true;
      this.didDrag = false;
      this.startX = event.clientX;
      this.startPosition = this.getCurrentPosition();
      this.position = this.startPosition;
    };

    onPointerMove = (event) => {
      if (!this.dragging) return;

      const delta = event.clientX - this.startX;
      if (!this.didDrag && Math.abs(delta) <= 4) return;

      if (!this.didDrag) {
        window.clearTimeout(this.resumeTimer);
        this.didDrag = true;
        this.classList.add('nobo-stories--dragging', 'nobo-stories--user-paused');
        this.viewport.setPointerCapture(event.pointerId);
      }

      this.position = this.startPosition + delta;
      this.position = this.wrapPosition(this.position);
      this.applyPosition();
      event.preventDefault();
    };

    onPointerUp = (event) => {
      if (!this.dragging) return;

      this.dragging = false;

      if (!this.didDrag) return;

      this.classList.remove('nobo-stories--dragging');

      if (this.viewport.hasPointerCapture(event.pointerId)) {
        this.viewport.releasePointerCapture(event.pointerId);
      }

      this.resumeTimer = window.setTimeout(() => {
        this.classList.remove('nobo-stories--user-paused');
      }, 2200);
    };

    onClick = (event) => {
      if (!this.didDrag) return;

      event.preventDefault();
      event.stopPropagation();
      this.didDrag = false;
    };

    getCurrentPosition() {
      const style = window.getComputedStyle(this.track);
      const transform = style.transform;

      if (!transform || transform === 'none') {
        return this.position || 0;
      }

      const matrix = new DOMMatrixReadOnly(transform);
      return matrix.m41;
    }

    getLoopWidth() {
      const cards = this.track.querySelectorAll('.nobo-stories__card');
      const visibleCount = Math.floor(cards.length / 2);

      if (!visibleCount) return 0;

      const card = cards[0];
      const gap = parseFloat(window.getComputedStyle(this.track).columnGap || window.getComputedStyle(this.track).gap || 0);
      return (card.getBoundingClientRect().width + gap) * visibleCount;
    }

    wrapPosition(position) {
      const loopWidth = this.getLoopWidth();

      if (!loopWidth) return position;

      while (position > 0) {
        position -= loopWidth;
      }

      while (position < -loopWidth) {
        position += loopWidth;
      }

      return position;
    }

    applyPosition() {
      this.track.style.transform = `translateX(${this.position}px)`;
    }
  }

  if (!customElements.get('nobo-stories-carousel')) {
    customElements.define('nobo-stories-carousel', NoboStoriesCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
